"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardProductionBoxComponent = void 0;
var vue_1 = require("vue");
var CardRenderItemComponent_1 = require("./CardRenderItemComponent");
var CardRenderSymbolComponent_1 = require("./CardRenderSymbolComponent");
var CardRenderSymbol_1 = require("../../cards/render/CardRenderSymbol");
var CardRenderItem_1 = require("../../cards/render/CardRenderItem");
exports.CardProductionBoxComponent = vue_1.default.component('CardProductionBoxComponent', {
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    components: {
        CardRenderItemComponent: CardRenderItemComponent_1.CardRenderItemComponent,
        CardRenderSymbolComponent: CardRenderSymbolComponent_1.CardRenderSymbolComponent,
    },
    methods: {
        getClasses: function () {
            var classes = ['card-production-box'];
            return classes.join(' ');
        },
        getComponentType: function (rowItem) {
            if (rowItem instanceof CardRenderSymbol_1.CardRenderSymbol) {
                return 'symbol';
            }
            else if (rowItem instanceof CardRenderItem_1.CardRenderItem) {
                return 'item';
            }
            return '';
        },
    },
    template: "\n        <div :class=\"getClasses()\">\n            <div class=\"card-production-box-row\" v-for=\"(rowData, index) in rows\" :key=\"index\">\n                <div v-for=\"(rowItem, rowIndex) in rowData\" class=\"card-production-box-row-item\" :key=\"rowIndex\">\n                    <CardRenderItemComponent v-if=\"getComponentType(rowItem) === 'item'\" :item=\"rowItem\"/>\n                    <CardRenderSymbolComponent v-else-if=\"getComponentType(rowItem) === 'symbol'\" :item=\"rowItem\" />\n                    <div v-else>n/a</div>\n                </div>\n            </div>\n        </div>\n    ",
});
//# sourceMappingURL=CardProductionBoxComponent.js.map